import { Model } from "../../classes/mvc/Model";

export class ModelDeliverCountries extends Model {
    
}